export default __webpack_public_path__ + "static/media/Facebook.d51f729d.svg";